export default "__VITE_ASSET__C$AWWMAq__"